import { publicFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiFirmRoute } from "@/lib/data/requests/firm/firm";

export const forgotPasswordV2 = async (email: string) => {
  return await publicFastApiAxiosInstance.post(
    `${baseFastApiFirmRoute}/forgot-password`,
    {
      email,
    },
  );
};

export const confirmForgotPasswordV2 = async (data: {
  email: string;
  newPassword: string;
  verificationCode: string;
}) => {
  return await publicFastApiAxiosInstance.post(
    `${baseFastApiFirmRoute}/confirm-forgot-password`,
    data,
  );
};
